"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorLayerSource_Base = void 0;
var ste_simple_events_1 = require("ste-simple-events");
var olExtent = require("ol/extent");
var olProj = require("ol/proj");
var Cluster_1 = require("ol/source/Cluster");
var VectorLayerSource_Base = /** @class */ (function () {
    function VectorLayerSource_Base(_map, _layer, _url, featureLoader, featureAdd, _loaderExtents, _logger) {
        var _this = this;
        this._map = _map;
        this._layer = _layer;
        this._url = _url;
        this.featureLoader = featureLoader;
        this.featureAdd = featureAdd;
        this._loaderExtents = _loaderExtents;
        this._logger = _logger;
        //event - SourceLoading
        this._onSourceLoading = new ste_simple_events_1.SimpleEventDispatcher();
        //event - SourceLoaded
        this._onSourceLoaded = new ste_simple_events_1.SimpleEventDispatcher();
        this.onLoading = function () {
            _this._onSourceLoading.dispatch({
                layer: _this._layer
            });
        };
        this.onLoaded = function (maxFeatureCountReached, featureCount, dataBounds, dataLoaded) {
            if (dataBounds !== null && !olExtent.isEmpty(dataBounds)) {
                _this._layer.loadedBounds = dataBounds;
            }
            _this._onSourceLoaded.dispatch({
                layer: _this._layer,
                maxFeatureCountReached: maxFeatureCountReached,
                featureCount: featureCount,
                dataBounds: dataBounds,
                dataLoaded: dataLoaded
            });
        };
        this.checkExtents = function (extent, displayProjection, dataProjection, vectorLayer, zoomLevel) {
            //which we need to do as we might to trigger a reload on zooming in, ol doesn't trigger this event for a reload
            var extentInDataProjection = olProj.transformExtent(extent, displayProjection, dataProjection);
            var changed = _this._loaderExtents.reloadLayer(extentInDataProjection, vectorLayer, zoomLevel, vectorLayer.group.maxFeatureCount);
            //buffer the extent by 15%
            var widthInMetres = olExtent.getWidth(extentInDataProjection);
            var buffered = olExtent.buffer(extentInDataProjection, widthInMetres * 0.15);
            //remove decimal points
            buffered[0] = parseFloat(buffered[0].toFixed(1));
            buffered[1] = parseFloat(buffered[1].toFixed(1));
            buffered[2] = parseFloat(buffered[2].toFixed(1));
            buffered[3] = parseFloat(buffered[3].toFixed(1));
            _this._logger.log(((changed) ? "Loading" : "NOT loading") + " data for " + vectorLayer.group.ref + " @zoom " + zoomLevel);
            return {
                extentsChanged: changed,
                currentExtent: extent,
                bufferedExtent: buffered
            };
        };
        this.clear = function () {
            if (_this.source) {
                _this.source.refresh();
                if (_this._loaderExtents) {
                    //clear the extents to make sure that the layer gets reloaded
                    _this._loaderExtents.clearExtent(_this._layer);
                }
                //if this is a cluster source clear the underlying vector source too
                if (_this.source instanceof Cluster_1.default) {
                    var src = _this.source.getSource();
                    src.refresh();
                }
            }
        };
        this.maxFeatureCount = _layer.group.maxFeatureCount;
    }
    Object.defineProperty(VectorLayerSource_Base.prototype, "onSourceLoading", {
        get: function () {
            return this._onSourceLoading.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayerSource_Base.prototype, "onSourceLoaded", {
        get: function () {
            return this._onSourceLoaded.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    return VectorLayerSource_Base;
}());
exports.VectorLayerSource_Base = VectorLayerSource_Base;
//# sourceMappingURL=VectorLayerSource_Base.js.map